import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Checkbox, Space } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

function Login() {
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  // Estado do segundo fator
  const [desafio, setDesafio] = useState(null);
  const [emailMascarado, setEmailMascarado] = useState('');
  const [codigo, setCodigo] = useState('');
  const [lembrar, setLembrar] = useState(false);
  const [enviandoEmail, setEnviandoEmail] = useState(false);
  const [aviso, setAviso] = useState('');

  const entrar = (dados) => {
    localStorage.setItem('token', dados.token);
    localStorage.setItem('usuario', JSON.stringify(dados.usuario));
    if (dados.dispositivo) localStorage.setItem('dispositivo_2fa', dados.dispositivo);
    window.location.href = '/dashboard';
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setErro('');
      const response = await axios.post('/api/auth/login', {
        email: values.email,
        senha: values.senha,
        dispositivo: localStorage.getItem('dispositivo_2fa') || undefined,
      });
      if (response.data && response.data.twofa) {
        setDesafio(response.data.desafio);
        setEmailMascarado(response.data.email || '');
        setCodigo('');
        setAviso('');
        return;
      }
      entrar(response.data);
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.erro;
      setErro(msg || 'E-mail ou senha incorretos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const verificar = async () => {
    if (!codigo || String(codigo).trim().length < 6) {
      setErro('Digite o c\u00f3digo completo.');
      return;
    }
    try {
      setLoading(true);
      setErro('');
      const r = await axios.post('/api/2fa/verificar', {
        desafio,
        codigo: String(codigo).trim(),
        lembrar,
      });
      entrar(r.data);
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.erro;
      setErro(msg || 'C\u00f3digo inv\u00e1lido.');
    } finally {
      setLoading(false);
    }
  };

  const enviarPorEmail = async () => {
    try {
      setEnviandoEmail(true);
      setErro('');
      const r = await axios.post('/api/2fa/enviar-email', { desafio });
      setAviso('C\u00f3digo enviado para ' + (r.data.email || emailMascarado) + '. Ele vale por 10 minutos.');
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.erro;
      setErro(msg || 'N\u00e3o consegui enviar o e-mail.');
    } finally {
      setEnviandoEmail(false);
    }
  };

  const voltar = () => {
    setDesafio(null);
    setCodigo('');
    setErro('');
    setAviso('');
  };

  const [semLogo, setSemLogo] = useState(false);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <Card style={{ width: 400, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: 12 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          {!semLogo ? (
            <img src="/api/logo-publica" alt="Celum Inspeções Técnicas" onError={() => setSemLogo(true)}
              style={{ maxWidth: 260, maxHeight: 110, objectFit: 'contain', display: 'block', margin: '0 auto 12px' }} />
          ) : (
          <div style={{ background: '#1a3c5e', borderRadius: 12, padding: '16px 24px', display: 'inline-block', marginBottom: 16 }}>
            <Title level={3} style={{ color: '#fff', margin: 0 }}>Celum ERP</Title>
          </div>
          )}
          <br />
          <Text type="secondary">{'Inspe\u00e7\u00f5es T\u00e9cnicas NR-13'}</Text>
        </div>

        {erro && <Alert message={erro} type="error" showIcon style={{ marginBottom: 16 }} />}
        {aviso && <Alert message={aviso} type="success" showIcon style={{ marginBottom: 16 }} />}

        {!desafio && (
          <Form name="login" onFinish={onFinish} layout="vertical" size="large">
            <Form.Item name="email" rules={[{ required: true, message: 'Informe seu e-mail' }, { type: 'email', message: 'E-mail inv\u00e1lido' }]}>
              <Input prefix={<UserOutlined />} placeholder="E-mail" />
            </Form.Item>
            <Form.Item name="senha" rules={[{ required: true, message: 'Informe sua senha' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Senha" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading} style={{ height: 48, fontSize: 16 }}>
                Entrar
              </Button>
            </Form.Item>
          </Form>
        )}

        {desafio && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <SafetyCertificateOutlined style={{ fontSize: 32, color: '#1a3c5e' }} />
              <div style={{ marginTop: 8, fontWeight: 600 }}>{'Verifica\u00e7\u00e3o em duas etapas'}</div>
              <Text type="secondary" style={{ fontSize: 13 }}>
                {'Digite o c\u00f3digo de 6 d\u00edgitos do aplicativo autenticador.'}
              </Text>
            </div>

            <Input
              size="large"
              autoFocus
              maxLength={9}
              value={codigo}
              onChange={e => setCodigo(e.target.value)}
              onPressEnter={verificar}
              placeholder="000000"
              style={{ textAlign: 'center', fontSize: 22, letterSpacing: 6, marginBottom: 12 }}
            />

            <Checkbox checked={lembrar} onChange={e => setLembrar(e.target.checked)} style={{ marginBottom: 12 }}>
              {'Lembrar deste computador por 30 dias'}
            </Checkbox>

            <Button type="primary" block size="large" loading={loading} onClick={verificar} style={{ height: 48, fontSize: 16, marginBottom: 12 }}>
              Confirmar
            </Button>

            <Space direction="vertical" size={4} style={{ width: '100%', textAlign: 'center' }}>
              <Button type="link" loading={enviandoEmail} onClick={enviarPorEmail}>
                {'Enviar c\u00f3digo por e-mail' + (emailMascarado ? ' (' + emailMascarado + ')' : '')}
              </Button>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {'Sem o celular e sem o e-mail? Use um dos seus c\u00f3digos de recupera\u00e7\u00e3o no campo acima.'}
              </Text>
              <Button type="link" size="small" onClick={voltar}>Voltar</Button>
            </Space>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>{'\u00a9 2026 Celum Inspe\u00e7\u00f5es T\u00e9cnicas'}</Text>
        </div>
      </Card>
    </div>
  );
}

export default Login;
